module.exports = __webpack_public_path__ + "img/melia-hotel.8703b4d6.jpg";